import axios from 'axios'
import qs from 'qs'

// let base='https://webmalls.ywechat.com';
let base='http://kingdom.us01.web.goomay.com.cn';
// axios.defaults.baseURL = base+'/wxapp/diban/Wxapp/';
axios.defaults.baseURL = base+'/wxapp/';
 
//请求拦截
axios.interceptors.request.use(
  config => {
	 //formData 这里要重新配置
    if (config.method === 'post' ) {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
  res => {
	return res
  },
  err => {
    return Promise.reject(err)
  }
)

// 发送请求
function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(
        res => {
          resolve(res.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject(err)
      })
  })
}
function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
        params: params
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}


export default{
	get,
	post,
	base
}